<div class="splash-content flex-layout-column flex-center-center">
  <div class="splash-logos flex-layout-row flex-center-center">
    <img [src]="BRAND.logo.main" alt="logo"/>
    <i *ngIf="!error" aria-hidden="true" class="fa fa-arrow-alt-circle-right success-text"></i>
    <i *ngIf="error" aria-hidden="true" class="fa fa-times-circle error-text"></i>
    <img [src]="website?.logo" alt="external website" onerror="this.src='./assets/common/globe.png'"/>
  </div>
  <div class="information-with-icon">
    <i *ngIf="!error" aria-hidden="true" class="fas fa-info fa-lg fa-fw success-text"></i>
    <p>
      {{ info }}
    </p>
    <br/>
    <p>
      {{ getRedirectText( error ) }}
      <br/>
      <a (click)="redirect()" [class]="error ? ThemeColorSettings.red : ThemeColorSettings.green"
         class="theme-color-link">
        {{ href }}
      </a>
    </p>
  </div>
  <div class="external-component-button-wrapper">
    <oth-button [routerLink]="URLS.root" i18n-text="@@externalRedirect.home.button" text="Home"></oth-button>
    <oth-button (click)="redirect()" i18n-text="@@externalRedirect.proceed.button" text="Proceed"></oth-button>
  </div>
</div>
